/* PATIRTI — sepet indirim teklifi
   Sepetinde urun olan musteri sepetten ayrilirken indirim kodunu gosterir;
   "Gebruik code" kodu /cart/update.js ile sepete kendisi uygular.

   Tetikler (oturumda en fazla bir kez, sepette urun ve gecerli kod yoksa):
   1) Sepet cekmecesi kapaninca
   2) Masaustunde imlec sayfanin ustunden disari cikinca (cikis niyeti)
   3) Mobilde baska uygulamaya/sekmeye gidip geri donunce

   Kod gecersiz cikarsa (kullanim limiti doldu, musteri daha once kullandi)
   sepetten geri alinir, teklif o ziyaretciye 7 gun gosterilmez.
   Metinler ve kod snippets/sepet-kod-teklifi.liquid icinde. */
(function () {
  'use strict';

  var dataEl = document.getElementById('kod-teklifi-data');
  var root = document.getElementById('kod-teklif');
  if (!dataEl) return;

  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var S = cfg.strings || {};
  var CODE = String(cfg.code || '');
  if (!CODE) return;

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var settings = theme.settings || {};
  var CART_URL = (routes.cart_url || '/cart') + '.js';
  var UPDATE_URL = (routes.cart_update_url || '/cart/update') + '.js';

  var SEEN_KEY = 'patirti:kodTeklifGosterildi';   // sessionStorage
  var DONE_KEY = 'patirti:kodTeklifBitti';        // localStorage, zaman damgasi
  var DONE_TTL = 7 * 24 * 60 * 60 * 1000;

  function store(kind) {
    try { return window[kind]; } catch (e) { return null; }
  }
  function getItem(kind, key) {
    var s = store(kind);
    try { return s ? s.getItem(key) : null; } catch (e) { return null; }
  }
  function setItem(kind, key, val) {
    var s = store(kind);
    try { if (s) s.setItem(key, val); } catch (e) {}
  }

  var seen = getItem('sessionStorage', SEEN_KEY) === '1';
  function isDone() {
    var t = parseInt(getItem('localStorage', DONE_KEY) || '0', 10);
    return t > 0 && Date.now() - t < DONE_TTL;
  }
  function markDone() { setItem('localStorage', DONE_KEY, String(Date.now())); }

  function formatMoney(cents) {
    var fmt = settings.moneyFormatActive || settings.moneyFormat || '€{{amount_with_comma_separator}}';
    var amount = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amount.split('.')[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amount.split('.')[0])
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function getCart() {
    return fetch(CART_URL, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function setDiscount(value) {
    return fetch(UPDATE_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: value })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function hasApplicableCode(cart) {
    return (cart.discount_codes || []).some(function (d) { return d.applicable; });
  }

  function isOnCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  /* ---------------- Pencere ---------------- */
  // root yoksa (snippet'te teklif_aktif = false) sadece cekmecedeki indirim satiri calisir
  var box = root ? root.querySelector('.kod-teklif__box') : null;
  var useBtn = root ? root.querySelector('[data-kod-teklif-use]') : null;
  var noBtn = root ? root.querySelector('.kod-teklif__no') : null;
  var msg = root ? root.querySelector('[data-kod-teklif-msg]') : null;
  var isOpen = false;
  var busy = false;
  var leaving = false;
  var lastFocus = null;
  var prevOverflow = '';

  function otherOverlayOpen() {
    var promo = document.querySelector('[data-promo-popup]');
    if (promo && !promo.hidden) return true;
    var age = document.querySelector('[data-age-verifier]');
    if (age && !age.hidden) return true;
    var qv = document.getElementById('quickview-overlay');
    if (qv && qv.classList.contains('is-open')) return true;
    return false;
  }

  function open() {
    if (isOpen || !root) return;
    isOpen = true;
    seen = true;
    setItem('sessionStorage', SEEN_KEY, '1');
    lastFocus = document.activeElement;
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    root.hidden = false;
    // Gecis animasyonu icin bir kare bekle
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-visible'); });
    });
    if (useBtn) useBtn.focus({ preventScroll: true });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-visible');
    root.hidden = true;
    document.body.style.overflow = prevOverflow;
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function maybeShow() {
    if (!root || seen || isOpen || busy || leaving || isDone()) return;
    busy = true;
    getCart().then(function (cart) {
      busy = false;
      if (!cart || cart.item_count < 1 || hasApplicableCode(cart)) return;
      if (seen || leaving || otherOverlayOpen()) return;
      open();
    });
  }

  function showMessage(text, isError) {
    if (!msg) return;
    msg.textContent = text;
    msg.classList.toggle('is-error', !!isError);
    msg.hidden = false;
  }

  function apply() {
    if (!useBtn || useBtn.disabled) return;
    useBtn.disabled = true;
    useBtn.textContent = S.applying || '…';
    if (msg) msg.hidden = true;

    setDiscount(CODE)
      .then(function (cart) {
        var entry = (cart.discount_codes || []).filter(function (d) {
          return String(d.code).toUpperCase() === CODE.toUpperCase();
        })[0];

        if (entry && entry.applicable) {
          markDone();
          renderDrawerDiscount(cart);
          var sub = document.querySelector('[data-cart-subtotal]');
          if (sub) sub.textContent = formatMoney(cart.total_price);
          root.classList.add('is-success');
          showMessage((S.success || '').replace('||T||', formatMoney(cart.total_price)), false);
          useBtn.hidden = true;
          if (noBtn) noBtn.hidden = true;
          setTimeout(afterSuccess, 1400);
          return;
        }

        // Gecersiz kodu sepette birakma — checkout'ta hata gostermesin
        markDone();
        return setDiscount('').catch(function () {}).then(fail);
      })
      .catch(fail);
  }

  function fail() {
    showMessage(S.error || '', true);
    if (useBtn) {
      useBtn.hidden = true;
      useBtn.disabled = false;
      useBtn.textContent = S.use || '';
    }
    if (noBtn) noBtn.textContent = S.close || noBtn.textContent;
  }

  // theme.js refreshCart'i disari acmiyor; sepet dugmesine basmak cekmeceyi
  // acip bastan cizer (kargo bari, ustu cizili toplam, indirim satiri birlikte)
  function redrawDrawer() {
    var toggle = document.getElementById('cart-toggle');
    if (settings.cartType !== 'drawer' || !toggle || !document.getElementById('cart-drawer')) return false;
    toggle.click();
    return true;
  }

  function afterSuccess() {
    close();
    if (isOnCartPage()) { window.location.reload(); return; }
    redrawDrawer();
  }

  if (root) {
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-kod-teklif-close]')) { close(); return; }
      if (e.target.closest('[data-kod-teklif-use]')) apply();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.stopPropagation(); close(); }
    if (e.key === 'Tab' && box) {
      var f = Array.prototype.filter.call(
        box.querySelectorAll('button, a[href]'),
        function (el) { return !el.hidden && !el.disabled && el.offsetParent !== null; }
      );
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  }, true);

  /* ---------------- Cekmecede indirim satiri ---------------- */
  function renderDrawerDiscount(cart) {
    var foot = document.querySelector('.cart-drawer__foot');
    if (!foot) return;
    Array.prototype.forEach.call(foot.querySelectorAll('.cart-kod-indirim'), function (el) { el.remove(); });
    if (!cart || cart.item_count < 1) return;
    var sub = foot.querySelector('.cart-subtotal');
    if (!sub) return;

    (cart.cart_level_discount_applications || []).forEach(function (a) {
      // update.js {amount, discount_application} doner, cart.js ise uygulamanin kendisini
      var app = a.discount_application || a;
      var amountCents = typeof a.amount === 'number' ? a.amount : app.total_allocated_amount;
      if (app.type !== 'discount_code' || !amountCents) return;

      var row = document.createElement('div');
      row.className = 'cart-kod-indirim';

      var label = document.createElement('span');
      label.className = 'cart-kod-indirim__label';
      label.appendChild(document.createTextNode((S.discountLabel || '') + ' '));
      var code = document.createElement('strong');
      code.textContent = app.title || '';
      label.appendChild(code);
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'cart-kod-indirim__remove';
      rm.setAttribute('data-kod-indirim-kaldir', '');
      rm.textContent = S.remove || '×';
      label.appendChild(rm);

      var amount = document.createElement('span');
      amount.className = 'cart-kod-indirim__amount';
      amount.textContent = '−' + formatMoney(amountCents);

      row.appendChild(label);
      row.appendChild(amount);
      sub.parentNode.insertBefore(row, sub);
    });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-kod-indirim-kaldir]');
    if (!rm) return;
    rm.disabled = true;
    setDiscount('')
      .then(function (cart) {
        if (isOnCartPage()) { window.location.reload(); return; }
        if (redrawDrawer()) return;
        renderDrawerDiscount(cart);
        var sub = document.querySelector('[data-cart-subtotal]');
        if (sub) sub.textContent = formatMoney(cart.total_price);
      })
      .catch(function () { rm.disabled = false; });
  });

  var refreshTimer = null;
  function refreshDrawerDiscount() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { getCart().then(renderDrawerDiscount); }, 60);
  }

  /* ---------------- Tetikler ---------------- */
  function boot() {
    var drawer = document.getElementById('cart-drawer');
    var drawerBody = document.getElementById('cart-drawer-body');

    if (drawer) {
      // theme.js ilk yuklemede sepeti cizer; o cizim bu gozlemciyi tetikler
      if (drawerBody && window.MutationObserver) {
        // Tema sepeti her yeniden cizdiginde indirim satirini da tazele
        new MutationObserver(refreshDrawerDiscount).observe(drawerBody, { childList: true });
      }
      if (window.MutationObserver) {
        var wasOpen = drawer.classList.contains('is-open');
        new MutationObserver(function () {
          var nowOpen = drawer.classList.contains('is-open');
          if (wasOpen && !nowOpen) setTimeout(maybeShow, 350);
          wasOpen = nowOpen;
        }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }

    if (!root) return;

    // Odeme sayfasina gecen musteriye teklif gosterme
    document.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if ((submitter && submitter.name === 'checkout') || (e.target.action || '').indexOf('/checkout') > -1) leaving = true;
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest('a[href*="/checkout"], [name="checkout"], [data-quickbuy], .shopify-payment-button')) leaving = true;
    }, true);

    var startedAt = Date.now();
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (finePointer) {
      document.addEventListener('mouseout', function (e) {
        if (e.relatedTarget || e.clientY > 0) return;
        if (Date.now() - startedAt < 3000) return;
        maybeShow();
      });
    } else {
      var hiddenAt = 0;
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') { hiddenAt = Date.now(); return; }
        if (hiddenAt && Date.now() - hiddenAt > 3000) setTimeout(maybeShow, 600);
        hiddenAt = 0;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
